// src/context/InstalmentContext.js

import React, { createContext, useContext, useState } from 'react';

// Create the context
const InstalmentContext = createContext();

// Define the provider component
export const InstalmentProvider = ({ children }) => {
    const [instalment, setInstalment] = useState(1);
    const [instalmentFee, setInstalmentFee] = useState(0); // Initialize as needed
    const [feePercentage, setFeePercentage] = useState(0); // Initialize as needed

    // Function to update instalment with validation
    const updateInstalment = (value) => {
        const newValue = Math.max(0, Math.min(12, value)); // Constrain between 1 and 12
        setInstalment(newValue);
    };

    // Function to update instalment fee
    const updateInstalmentFee = (fee) => {
        setInstalmentFee(fee);
    };

    // Function to update fee percentage
    const updateFeePercentage = (percentage) => {
        setFeePercentage(percentage);
    };

    return (
        <InstalmentContext.Provider
            value={{
                instalment,
                setInstalment: updateInstalment,
                instalmentFee,
                setInstalmentFee: updateInstalmentFee,
                feePercentage,
                setFeePercentage: updateFeePercentage,
            }}
        >
            {children}
        </InstalmentContext.Provider>
    );
};

// Custom hook to use the InstalmentContext
export const useInstalment = () => {
    const context = useContext(InstalmentContext);
    if (!context) {
        throw new Error("useInstalment must be used within an InstalmentProvider");
    }
    return context;
};
